"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

require("../Style.css");

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsArticles = function NewsArticles(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var NewsArticleslist = [];
  if (props.news_articles) {
    for (var i = 0; i < props.news_articles.length; i++) {
      NewsArticleslist.push(_react2.default.createElement(
        "div",
        { key: props.news_articles[i].title, className: "article" },
        _react2.default.createElement(
          "figure",
          null,
          _react2.default.createElement("img", {
            src: props.news_articles[i].image,
            alt: props.news_articles[i].title
          })
        ),
        _react2.default.createElement(
          "h3",
          null,
          _react2.default.createElement(
            "span",
            null,
            props.news_articles[i].title
          )
        ),
        _react2.default.createElement(
          "p",
          null,
          props.news_articles[i].text
        ),
        _react2.default.createElement(
          "div",
          { id: "link" },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: "/news-details/" + props.news_articles[i].id },
            "Lees verder",
            _react2.default.createElement(_idbReactIconlib2.default, { name: "ArrowDoubleRight" })
          )
        )
      ));
    }
  }
  return _react2.default.createElement(
    "section",
    {
      id: "newsArticles",
      className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "light" : props.theme].join(" ")
    },
    _react2.default.createElement(
      "div",
      { className: "sectionWrapper" },
      _react2.default.createElement(
        "h2",
        null,
        props.title
      ),
      props.news_articles ? _react2.default.createElement(
        "div",
        { className: "container" },
        NewsArticleslist
      ) : _react2.default.createElement(
        "div",
        { className: "modNoData" },
        "No data received"
      )
    )
  );
};

exports.default = NewsArticles;